import { render, staticRenderFns } from "./SituacaoAtendimentoSetting.vue?vue&type=template&id=58cc41c1"
import script from "./SituacaoAtendimentoSetting.vue?vue&type=script&lang=js"
export * from "./SituacaoAtendimentoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports